import '../item.scss';
import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ButtonSecondary from '@components/atoms/buttons/ButtonSecondary';

const ItemBullet = ({
	modifiers,
	className,
	image,
	title,
	titleTag,
	text,
	list,
	link,
	...otherProps
}) => {
	const baseClass = 'item-bullet';
	const defaultClass = 'item';

	const rootClass = cx(baseClass, className, defaultClass, {
		[`${baseClass}--${modifiers}`]: modifiers,
	});

	const HTag = `${titleTag}`;

	return (
		<div className={rootClass} data-item {...otherProps}>
			<div className="item__title">
				<img src={image} alt={title || ''} loading="lazy" />
				<HTag className="item__titletag">{title}</HTag>
			</div>
			{text && text.length > 0 && (
				<div className="item__text">
					{text.map((p, index) => {
						return <p key={`line-${index}`}>{p}</p>;
					})}
				</div>
			)}
			{list && list.length > 0 && (
				<ul className="item__text">
					{list.map((li, index) => {
						return <li key={`li-${index}`}>{li}</li>;
					})}
				</ul>
			)}
			{link && (
				<ButtonSecondary
					href={link.url}
					text={link.title}
					data-target
				/>
			)}
		</div>
	);
};

ItemBullet.defaultProps = {
	titleTag: 'h4',
};

ItemBullet.propTypes = {
	modifiers: PropTypes.string,
	className: PropTypes.string,
	image: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	titleTag: PropTypes.string,
	text: PropTypes.array,
	list: PropTypes.array,
	link: PropTypes.object,
};

export default ItemBullet;
